export var Confidence;
(function (Confidence) {
    Confidence["Low"] = "LOW";
    Confidence["MediumLow"] = "MEDIUM_LOW";
    Confidence["Medium"] = "MEDIUM";
    Confidence["MediumHigh"] = "MEDIUM_HIGH";
    Confidence["High"] = "HIGH";
})(Confidence || (Confidence = {}));
//# sourceMappingURL=Confidence.js.map